// import { useAppDispatch } from '../../redux/hooks'
// import { toggleAppShowSearchMenu } from '../../redux/reducers/searchSlice'
import { useState } from 'react'
import './style.scss'

function HeaderAppCommunities() {

	// const dispatch = useAppDispatch()
	const [communitiesSearchValue, setCommunitiesSearchValue] = useState<string>('')

	const searchButtonClickHandler = () => {
		// dispatch(toggleAppShowSearchMenu())
	}

	return (
		<div className="header-app-explore-wrap">
			<div className="header-app-explore-wrap-inner">
				<div className='header-app-header-button-wrap'>
					<img
						src={'/imgs/icons/instructor/icon-instructor-header-bell-button.svg'}
						className='header-app-header-button-img'
						alt='Bell Button'
					/>
				</div>
				<div className='header-app-header-button-wrap'>
					<img
						src={'/imgs/icons/community/header-text-communities.svg'}
						className='header-app-header-button-img header-app-header-button-img-middle'
						alt='Lessons Text'
					/>
				</div>
				<div 
					className='header-app-header-button-wrap'
				>
				</div>
			</div>
			<div className='header-app-header-buttons'>
				<div 
					className='header-app-header-button-round'
					onClick={() => {
						searchButtonClickHandler()
					}}
				>
					<img
						src={'/imgs/icons/explore/icon-search.svg'}
						className='header-app-header-search-img'
						alt='Search Icon'
					/>
					<input 
						className='header-app-header-button-round-input'
						placeholder='Search'
						value={communitiesSearchValue ? communitiesSearchValue : ''}
						onChange={(evt) => {
							setCommunitiesSearchValue(evt.target.value)
						}}
					/>
				</div>
				
			</div>
		</div>
	)
}

export default HeaderAppCommunities